import { ContentType, Filter, Sort } from '@/swagger/constants/contents-orchestrator-enums';

export const en = {
  trainingSoftSkills: {
    pageTitle: 'Training',
    trainingSoftSkillsTitleEmployee: 'Improve your soft skills',
    trainingSoftSkillsTitleAdmin: 'Soft skills training and growth',
    description:
      'Explore guides, video courses, and quizzes designed to help your employees develop the most in-demand soft skills.\nFor each piece of content, you can also see how many times it has been viewed and the average rating it received from users, giving you an immediate sense of its relevance.',
    cards: {
      VIDEO: {
        start: 'Watch now',
        resume: 'Continue watching',
        restart: 'Restart Video',
        duration: '{{time}} min',
      },
      DOCUMENT: {
        start: 'View',
        resume: 'Resume',
        restart: 'Restart',
        duration: 'Reading time: {{time}} minutes',
      },
      QUIZ: {
        start: 'Start',
        resume: 'Resume',
        restart: 'Restart',
        questions: '{{questions}} Questions',
        duration: '{{time}} min',
        progress: 'Questions: {{current}}/{{total}}',
      },
      GENERIC: {
        completed: 'Completed',
        inProgress: 'In progress',
        newVersion: 'New version',
        credits: '{{credits}} Credits',
        skillToBoost: 'Skill to boost',
      },
    },
    sections: {
      newContents: {
        title: 'New',
        subTitle: 'Check out the latest content updates',
      },
      myContents: {
        title: 'Your content',
        subTitle: 'Find saved, ongoing, or completed content',
        showAll: 'Show all',
      },
      contentsInProgress: {
        title: 'Continue your courses',
        [ContentType.VIDEO]: 'Continue your videos',
        [ContentType.PDF]: 'Continue your PDFs',
        [ContentType.QUIZ]: 'Continue your quizzes',
      },
      mainContents: {
        title: 'All courses',
        titleVideo: 'Video content',
        titleDocuments: 'Useful documents',
        titleQuizzes: {
          admin: 'Quizzes',
          learning: 'Test yourself',
        },
        descriptionQuizzes:
          'Check how much you’ve learned with our quizzes dedicated to soft skills. Each attempt gives you 10 different randomly selected questions to help you consolidate your knowledge and track your progress.',
        showAll: 'Show all',
        noContent: 'No content available',
      },
      paginatedContents: {
        title: {
          saved: 'Your courses',
          [ContentType.VIDEO]: 'All videos',
          [ContentType.PDF]: 'All PDFs',
          [ContentType.QUIZ]: 'All quizzes',
        },
      },
    },
    filtersAndOrderContent: {
      filter: 'Filter',
      orderBy: 'Sort by',
      search: 'Search',
      discard: 'Cancel',
      apply: 'Save',
      orders: {
        sortBy: {
          [Sort.MOSTRECENT]: 'Most recent',
          [Sort.HIGHESTRATING]: 'Highest rating',
        },
      },
      filters: {
        type: {
          placeHolder: 'Format',
          [ContentType.VIDEO]: 'Video',
          [ContentType.PDF]: 'PDF',
          [ContentType.QUIZ]: 'Quiz',
        },
        state: {
          placeHolder: 'Status',
          [Filter.ISCOMPLETED]: 'Completed',
          [Filter.ISSAVED]: 'Saved',
        },
      },
      tags: {
        all: 'All',
      },
    },
    emptyState: {
      noContents: 'No content available at the moment. Please try again later.',
    },
    tutorial: {
      learning: {
        title: 'Discover Soft Skills Training',
        close: 'Close',
        next: 'Next',
        previous: 'Back',
        goToGuide: 'Go to guide',
        slides: {
          slide1: {
            title: 'Explore content and test yourself',
            description:
              'Browse the available content in the catalog and test your knowledge. You will find content related to skills with growth potential tagged as "Skill to Boost".',
          },
          slide2: {
            title: 'Your content',
            description:
              'In the "Your content" section you can keep track of what you have saved, completed, and what is still in progress. Leave your feedback on content to help others find their way.',
          },
        },
      },
      admin: {
        title: 'Discover Soft Skills Training',
        close: 'Close',
        next: 'Next',
        previous: 'Back',
        goToGuide: 'Go to guide',
        slides: {
          slide1: {
            title: 'Quick search and essential data',
            description:
              'View the list of all available content. Use category filters and the search bar to find the materials you need and view key data such as average rating and duration.',
          },
          slide2: {
            title: 'Complete content preview',
            description:
              'As an Admin, you can view all materials available in the catalog to assess their training value for your people. Based on assessment results, the platform tags content related to less developed skills across the organization with "Skill to boost".',
          },
          slide3: {
            title: 'Explore all content',
            description:
              'Discover the entire training catalog of the platform: find videos, materials, and quizzes organized by type for simple and immediate navigation.',
          },
        },
      },
    },
  },
};
